'use client';

import { useAuth } from '@/app/user-and-session/session-auth/hooks/useAuth';
import { useRouter } from 'next/navigation';
import { WalletIcon } from 'lucide-react';
import { useTranslations } from 'next-intl';

interface SubscriptionButtonProps {
  className?: string;
  isCollapsed?: boolean;
}

export default function SubscriptionButton({ className, isCollapsed = false }: SubscriptionButtonProps) {
  const { session, userEmail, isAuthenticated } = useAuth();
  const router = useRouter();
  const t = useTranslations('nav');

  const handleClick = () => {
    router.push('/subscription');
  };

  return (
    <div className="w-full">
      <button
        onClick={handleClick}
        className={`flex items-center gap-3 w-full rounded-[12px] h-auto transition-colors duration-200 group hover:bg-[#ffffff1a] ${isCollapsed ? 'justify-center px-2 py-3' : 'justify-start px-3 py-2.5 2xl:py-3.5'} ${className}`}
        title={isCollapsed ? t('balance') : undefined}
      >
        <WalletIcon className="w-6 h-6 text-[#8f9092] group-hover:text-white" />
        {!isCollapsed && (
          <span className="font-medium text-base tracking-[-0.32px] leading-5 text-left flex-1 text-[#8f9092] group-hover:text-white [font-family:'Montserrat',Helvetica]">
            {t('balance')}
          </span>
        )}
      </button>
    </div>
  );
} 